import {
    RENTER_ORDER_LIST,
    RENTER_ORDER_LIST_SUCCESSFUL,
    RENTER_ORDER_LIST_FAILED
} from "./actionTypes";

const initialState = {
    OrderError: null,
    loading: false,
    orderListData: null,
    isOrderSuccess: false,
    isOrderError: false
};


const RenterOrderReducer = (state = initialState, action) => {

    switch (action.type) {
        case RENTER_ORDER_LIST:
            state = {
                ...state,
                loading: true,
                OrderError: null,
                orderListData: null,
                isOrderSuccess: false,
                isOrderError: false
            };
            break;
        case RENTER_ORDER_LIST_SUCCESSFUL:
            state = {
                ...state,
                loading: false,
                orderListData: action.payload,
                isOrderSuccess: true,
                OrderError: null,
                isOrderError: false,
            };
            break;
        case RENTER_ORDER_LIST_FAILED:
            state = {
                ...state,
                orderListData: null,
                loading: false,
                OrderError: action.payload,
                isOrderError: true,
                isOrderSuccess: false,
            };
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
};

export default RenterOrderReducer;
